export const defaultProperty = {
  address: "",
  buildingClass: "A",
  buildingSize: null,
  lotSize: "",
  lotSizeUnits: "acres",
  city: "",
  county: "",
  state: "",
  stories: "",
  submarket: "",
  databaseId: null,
  propertyTypeId: "1",
  propertySubtypeId: "101",
  typicalFloorSize: null,
  yearBuilt: null,
  zip: "",
  served: false,
  ready: false,
  driveThroughAccess: false
};

export const propertyTypeSubtypeMap = [
  {
    id: "1",
    name: "Office",
    subtypes: [
      { name: "Office Building", id: "101" },
      { name: "Creative/Loft", id: "102" },
      { name: "Executive Suites", id: "103" },
      { name: "Medical", id: "104" },
      { name: "Institutional/Governmental", id: "105" },
      { name: "Office Warehouse", id: "106" },
      { name: "Coworking", id: "108" },
      { name: "Lab", id: "109" }
    ]
  },
  {
    id: "2",
    name: "Retail",
    subtypes: [
      { name: "Street Retail", id: "201" },
      { name: "Strip Center", id: "202" },
      { name: "Free Standing Building", id: "203" },
      { name: "Regional Mall", id: "204" },
      { name: "Retail Pad", id: "205" },
      { name: "Vehicle Related", id: "206" },
      { name: "Outlet Center", id: "207" },
      { name: "Power Center", id: "208" },
      { name: "Neighborhood Center", id: "209" },
      { name: "Community Center", id: "210" },
      { name: "Specialty Center", id: "211" },
      { name: "Theme/Festival Center", id: "212" },
      { name: "Restaurant", id: "213" },
      { name: "Post Office", id: "214" },
      { name: "Lifestyle Center", id: "216" }
    ]
  },
  {
    id: "3",
    name: "Industrial",
    subtypes: [
      { name: "Manufacturing", id: "301" },
      { name: "Warehouse/Distribution", id: "302" },
      { name: "Flex Space", id: "303" },
      { name: "Research & Development", id: "304" },
      { name: "Refrigerated/Cold Storage", id: "305" },
      { name: "Office Showroom", id: "306" },
      { name: "Truck Terminal/Hub/Transit", id: "307" },
      { name: "Self Storage", id: "308" },
      { name: "Data Center", id: "310" }
    ]
  },
  {
    id: "5",
    name: "Land",
    subtypes: [
      { name: "Office", id: "501" },
      { name: "Retail", id: "502" },
      { name: "Retail-Pad", id: "503" },
      { name: "Industrial", id: "504" },
      { name: "Residential", id: "505" },
      { name: "Multifamily", id: "506" },
      { name: "Other", id: "507" }
    ]
  },
  {
    id: "6",
    name: "Multifamily",
    subtypes: [
      { name: "High-Rise", id: "601" },
      { name: "Mid-Rise", id: "602" },
      { name: "Low-Rise/Garden", id: "603" },
      { name: "Government Subsidized", id: "604" },
      { name: "Mobile Home Park", id: "605" },
      { name: "Senior Living", id: "606" },
      { name: "Skilled Nursing", id: "607" },
      { name: "Single Family Rental Portfolio", id: "608" }
    ]
  },
  {
    id: "7",
    name: "Special Purpose",
    subtypes: [
      { name: "School", id: "701" },
      { name: "Marina", id: "702" },
      { name: "Other", id: "703" },
      { name: "Golf Course", id: "704" },
      { name: "Church", id: "705" }
    ]
  },
  {
    id: "8",
    name: "Hospitality",
    subtypes: [
      { name: "Full Service", id: "801" },
      { name: "Limited Service", id: "802" },
      { name: "Select Service", id: "803" },
      { name: "Resort", id: "804" },
      { name: "Economy", id: "805" },
      { name: "Extended Stay", id: "806" },
      { name: "Casino", id: "807" }
    ]
  }
];

export const yesNoOptions = [
  ["Yes", "yes"],
  ["No", "no"],
  ["N/A", ""]
];

export const propertyUseIdOptions = [
  ["Net Leased Investment", "1"],
  ["Investment", "2"],
  ["Owner / User", "3"],
  ["Business for Sale", "4"],
  ["Development", "5"]
];

export const constructionStatusOptions = [
  ["Existing", "1"],
  ["Under construction", "2"],
  ["Proposed", "3"],
  ["Build to suit", "4"]
];

export const parkingTypeOptions = [
  "Roof-Top", "Structure", "Surface", "Underground", "Other"
];

export const conditionOptions = [
  "Excellent", "Good", "Average", "Fair", "Poor"
];

export const broadbandOptions = [
  "Cable", "DSL", "ISDN", "Satellite", "T1/T3", "Gigabit", "Dialup", "Other"
];

export const retailClienteleTypes = [
  "General", "Family", "Business", "Traveler", "Tourist", "Recreation", "Convention", "Casino", "Other"
];

export const lotStabilizationOptions = [
  ["Stabilized", "stabilized"],
  ["Concrete", "concrete"]
];

export const lotBorderTypeOptions = [
  ["Fenced", "fenced"],
  ["Secured", "secured"]
];

export const servedRailProviderOptions = [
  ["UP", "up_served"],
  ["BNSF", "bnsf_served"],
  ["KCS", "kcs_served"],
  ["Dual", "dual_served"]
];

export const availableRailProviderOptions = [
  ["UP", "up_available"],
  ["BNSF", "bnsf_available"],
  ["KCS", "kcs_available"],
  ["Dual", "dual_available"]
];

export const tenancyIdOptions = [
  ["Single", "1"],
  ["Multiple", "2"]
];

export const soilTypeOptions = [
  "Clay",
  "Gravel",
  "Loam",
  "Mixed",
  "Muck",
  "Rock",
  "Stone",
  "Sandy",
  "Other"
];
